module.exports = __webpack_public_path__ + "img/fondo2.4b62a22d.svg";